export enum TaskStatus {
  TO_DO = "TO_DO",
  DOING = "DOING",
  COMPLETED = "COMPLETED",
}

export enum TaskPriority {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}
